import React from 'react';
import { Context } from './Video.types';

export const context = React.createContext<Context>({
  vehicle: null,
  selectedCam: 1,
  onSelectCam: () => null,
  requestId: null,
  toggleDetailsOpen: () => null,
});
